module.exports = __webpack_public_path__ + "static/media/30.5a26c505.jpg";